module.exports = __webpack_public_path__ + "assets/scene-text1.png";